import { render, staticRenderFns } from "./teamLeft.vue?vue&type=template&id=2373d5ad&scoped=true"
import script from "./teamLeft.vue?vue&type=script&lang=js"
export * from "./teamLeft.vue?vue&type=script&lang=js"
import style0 from "./teamLeft.vue?vue&type=style&index=0&id=2373d5ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2373d5ad",
  null
  
)

export default component.exports